"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isStandardLinkUnsafe = exports.isStandardLink = exports.standardLinkUseableDef = void 0;
const echain_shared_quantities_1 = require("@igus/echain-shared-quantities");
const schemaVersions_1 = require("../schemaVersions");
const echain_shared_modelling_1 = require("@igus/echain-shared-modelling");
const KetteSerieType_1 = require("../kette/KetteSerieType");
exports.standardLinkUseableDef = {
    parent: schemaVersions_1.linkLatestUseableDef,
    validation: {
        KetteSerieType: (v) => v === KetteSerieType_1.KetteSerieType.default,
        Teilung: echain_shared_quantities_1.isQuantityJson,
        Bezeichnung: true,
        Aussenhoehe: true,
        Biegeradius: true,
    },
    unsafeValidation: {
        KetteSerieType: (v) => v === KetteSerieType_1.KetteSerieType.default,
    },
};
exports.isStandardLink = echain_shared_modelling_1.UseableUtil.createGuard(exports.standardLinkUseableDef);
exports.isStandardLinkUnsafe = echain_shared_modelling_1.UseableUtil.createUnsafeGuard(exports.standardLinkUseableDef);
//# sourceMappingURL=StandardLink.js.map